import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  class: "result content is-medium box",
  id: "result"
}
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-primary is-light" }, [
  /*#__PURE__*/_createTextVNode(" ⭐ Remember to "),
  /*#__PURE__*/_createElementVNode("b", null, "bookmark"),
  /*#__PURE__*/_createTextVNode(" this page so you can "),
  /*#__PURE__*/_createElementVNode("b", null, "generate UUIDs"),
  /*#__PURE__*/_createTextVNode(" next time faster ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, " Welcome to our UUID generator website! Here you can easily generate unique universally unique identifiers (UUIDs) without the need to install any software on your computer. UUIDs are a standard format for creating unique identifiers that are globally unique across all devices and systems. They can be used in a variety of applications, such as generating unique identifiers for databases, files, or other resources. Our UUID generator is easy to use and generates truly random UUIDs, ensuring that each one is unique. Simply click the \"Generate\" button and a new UUID will be generated for you to use in your application. Try it out now and see how UUIDs can simplify your unique identifier needs! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.msg), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.newUuid), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["button is-info is-light", { 'is-loading': _ctx.isLoading }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateNewUuid && _ctx.generateNewUuid(...args)))
      }, "Generate New UUID", 2)
    ]),
    _hoisted_5,
    _hoisted_6
  ], 64))
}